export default __webpack_public_path__ + "static/media/05-professional_preview.08d92ed1.jpg";